import React from "react";

const CONTACT_US = "https://www.yourgolftravel.com/contact-us";
const LICENSE = "https://creativecommons.org/licenses/by-nc-nd/4.0/";
const TRANS = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
const WIDTH = "720 px";

const meta = props => (
  <React.Fragment>
    <meta content={props.venueName} itemProp="caption" />
    <meta content={props.venueImageUrlPalmAndUp} itemProp="contentUrl" />
    <meta content={LICENSE} itemProp="license" />
    <meta content={CONTACT_US} itemProp="acquireLicensePage" />
    <meta content={props.venueImageUrlSmallPalm} itemProp="thumbnailUrl" />
    <meta content={WIDTH} itemProp="width" />
  </React.Fragment>
);

const picture = props => (
  <picture data-defer="" itemScope itemType="https://schema.org/ImageObject">
    {meta(props)}
    <source media="(min-width: 801px)" data-srcset={props.venueImageUrlPalmAndUp} />
    <img
      alt={props.venueName}
      decoding="async"
      height="1"
      width="1"
      data-srcset={props.venueImageUrlSmallPalm}
      data-type="package"
      src={TRANS}
    />
  </picture>
);

const PackageImage = props => (
  <div aria-label={`${props.venueName} image`} role="img" data-responsive="">
    {picture(props)}
  </div>
);

export default PackageImage;



// WEBPACK FOOTER //
// ./components/search/package/PackageImage.jsx